import AppContext, { AppContexts } from "components/app-context";
import { useContext } from "react";
import { getCreateProjectUrl } from "utils/utils";

export const useIsAdmin = () => {
	const context = useContext(AppContext);
	return context === AppContexts.admin;
};

export const useIsLiveEvent = () => {
	const context = useContext(AppContext);
	return context === AppContexts.liveEvent;
};

/**
 * Detects whether the app is running inside the Brandlive admin platform's preview iframe.
 * True when embedded in an iframe whose parent is the create project URL.
 */
export const useIsPlatformIframe = (): boolean => {
	try {
		return window.self !== window.top && document.referrer.startsWith(getCreateProjectUrl());
	} catch {
		// Cross-origin access to window.top throws — treat as iframed
		return true;
	}
};
